module.exports = __webpack_public_path__ + "static/media/Vitality.e1dd8582.png";